import client from './client';

const API_URL = '/api/lessons';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchLessons = async () => {
    try {
        const response = await client.get(API_URL, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching lessons:', error);
        throw error;
    }
};

export const fetchLessonById = async (id) => {
    try {
        const response = await client.get(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching lesson ${id}:`, error);
        throw error;
    }
};

export const createLesson = async (lessonData) => {
    try {
        const response = await client.post(API_URL, lessonData, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error creating lesson:', error);
        throw error;
    }
};

export const updateLesson = async (id, lessonData) => {
    try {
        const response = await client.put(`${API_URL}/${id}`, lessonData, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error updating lesson ${id}:`, error);
        throw error;
    }
};

export const deleteLesson = async (id) => {
    try {
        const response = await client.delete(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error deleting lesson ${id}:`, error);
        throw error;
    }
};

export const fetchCalendarLessons = async (start, end) => {
    try {
        const response = await client.get(`${API_URL}/calendar`, {
            params: { start, end },
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching calendar lessons:', error);
        throw error;
    }
};

export const fetchDraftLessons = async () => {
    try {
        const response = await client.get(`${API_URL}/drafts`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching draft lessons:', error);
        throw error;
    }
};

export const createMultipleLessons = async (lessons) => {
    try {
        const response = await client.post(`${API_URL}/batch`, { lessons }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error creating multiple lessons:', error);
        throw error;
    }
};

export const generateLessonContent = async (id, { lessonTopic } = {}) => {
    try {
        const response = await client.post(`${API_URL}/${id}/generate`, { lessonTopic }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error generating lesson ${id}:`, error);
        throw error;
    }
};

export const scheduleLesson = async (id, scheduledDate) => {
    try {
        const response = await client.patch(`${API_URL}/${id}/schedule`, { scheduledDate }, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error scheduling lesson ${id}:`, error);
        throw error;
    }
};
